import React, { useState } from 'react';
import FadeIn from '../common/FadeIn';
import { HiArrowLongDown } from "react-icons/hi2";

const faqItems = [
  {
    id: 1,
    question: "Do I need to design the website myself?",
    answer: "No. Just choose a design you like, and I will customize it for you."
  },
  {
    id: 2,
    question: "Can I change the content?",
    answer: "Yes. Your text, images, logo, colors, and other details can be changed."
  },
  {
    id: 3,
    question: "Can I request changes before launch?",
    answer: "Yes. You can review the website and request changes before it goes live."
  },
  {
    id: 4,
    question: "Will the website work on mobile?",
    answer: "Yes. It will work properly on mobile, tablet, and desktop."
  },
  {
    id: 5,
    question: "Can you connect my domain?",
    answer: "Yes. I can connect your existing domain or help you set up a new one."
  },
  {
    id: 6,
    question: "Do you provide hosting?",
    answer: "Yes. Hosting is available with the setup and maintenance service."
  },
  {
    id: 7,
    question: "Can I update the website later?",
    answer: "Yes. You can request changes or updates whenever needed."
  },
  {
    id: 8,
    question: "Do I need to provide my own content?",
    answer: "Yes. You will need to provide your logo, text, images, and videos."
  },
  {
    id: 9,
    question: "What happens after launch?",
    answer: "I will check the website once more to make sure everything is working properly."
  }
];

const ServiceFaqSection = () => {
  const [openIds, setOpenIds] = useState([]);

  const toggleFaq = (id) => {
    setOpenIds((prev) =>
      prev.includes(id) ? prev.filter((itemId) => itemId !== id) : [...prev, id]
    );
  };

  return (
    <section className="w-full md:p-[100px_0px_70px] text-[#1C1917] px-6">
      <div className="max-w-[960px] mx-auto flex flex-col gap-4 sm:gap-5 md:gap-6">
        {faqItems.map((item) => {
          const isOpen = openIds.includes(item.id);

          return (
            <FadeIn key={item.id} className="w-full">
              <div className="w-full overflow-hidden">

                <div className="border border-transparent bg-[#f9f6f3]">
                  <button
                    onClick={() => toggleFaq(item.id)}
                    className="w-full px-5 py-4 md:px-8 md:py-4 flex items-center justify-between text-left cursor-pointer transition-colors gap-4"
                    aria-expanded={isOpen}
                  >
                    <span className="font-PromenadeItalic text-[16px] md:text-[20px] leading-[1.4] tracking-[0.05em] font-normal">
                      {item.question}
                    </span>

                    <span className={`text-[#4A433A] transition-transform duration-500 ease-in-out flex-shrink-0 ${isOpen ? 'rotate-180' : ''}`}>
                      <HiArrowLongDown className="w-4 h-4 md:w-5 md:h-5" />
                    </span>
                  </button>
                </div>

                <div
                  className={`grid transition-all duration-500 ease-in-out ${isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
                    }`}
                >
                  <div className="overflow-hidden">
                    <div className="px-5 sm:px-8 pt-4 sm:pt-5 pb-5 sm:pb-6 text-[#554E45]">
                      <p className="font-interDisplayMedium text-[15px] md:text-base leading-[1.6] tracking-[0em] font-normal">
                        {item.answer}
                      </p>
                    </div>
                  </div>
                </div>

              </div>

            </FadeIn>
          );
        })}
      </div>
    </section>
  );
};

export default ServiceFaqSection;
